module.exports = __webpack_public_path__ + "f44dc64cf36caac7f6a595f3947369dd.MP3";